import { Card, Carousel } from '@boltenergy-be/design-system'
import ReviewRatings from 'components/review-ratings/ReviewRatings'
import { useTranslation } from 'next-i18next/pages'
import styles from './UspTestimonials.module.scss'
import { UspTestimonialsProps } from './types'

const UspTestimonials = ({ ratings, reviews }: UspTestimonialsProps) => {
  // i18n
  const { t } = useTranslation('usps')

  return (
    <Carousel
      title={t('testimonialsTitle')}
      aboveTitleSlot={ratings ? <ReviewRatings show={ratings} /> : undefined}
      color="light"
      classnames={{
        slide: styles['testimonial-slide'],
        heading: styles['testimonial-heading'],
        container: styles['testimonial-container']
      }}
    >
      {reviews.map(({ text, author, job }) => (
        <Card key={`testimonial-${author}`} as="figure" color="warm" shadow={false} className={styles.testimonial}>
          <blockquote>{text}</blockquote>
          <figcaption className={styles['testimonial-caption']}>
            <strong>{author}</strong>
            {!!job && <small>{job}</small>}
          </figcaption>
        </Card>
      ))}
    </Carousel>
  )
}

export default UspTestimonials
